import Options from './Options';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { withModel } from '../../../../data-providers/model';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import withQueryParams from '../../../../hocs/withQueryParams';
import qs from 'qs';

const enhance = compose(
  withModel,
  withQueryParams,
  withProps(props => {
    const countryDropdownList = props.model.prismicCountryListModel.slices.find(
      slice => slice.type === 'CountryDropdownList',
    );

    // Get the current page Prismic UID
    const uid = props.model.prismicPageModel.metadata.uid;
    // Check if the uid is the homepage so that we dont need to add a return to uid query param
    const isHomepage = uid.includes('homepage');
    const isBlog = props.model.prismicPageModel.isBlog;
    const search = props.queryParams;

    switch (true) {
      case isBlog:
        search.return_to = 'blog';
        break;
      case !isHomepage:
        search.return_to_uid = uid;
        break;
    }

    const query = qs.stringify(search, { addQueryPrefix: true });

    const inputUrl = `/choose-your-country${query}`;

    return {
      changeCountry: {
        flag: countryDropdownList.primary.otherCountryImage,
        name: props.model.prismicNavigationModel.changeCountryLink,
        prefix: props.model.countryModel.prefix,
        iso: '',
        href: localiseUrl(props.model.countryModel, inputUrl),
      },
      options: props.countries.filter(
        country =>
          !!countryDropdownList.items.find(
            item =>
              item.iso === country.iso &&
              country.contentLocales.includes(item.localeCode.toLowerCase()),
          ),
      ),
    };
  }),
);

export default enhance(Options);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Header/CountryToggle/Options/index.js